/* Bear Baby Boutique – "Meer laden" voor collectiegrids.
   Haalt de volgende pagina op via de Section Rendering API en voegt de producten toe aan
   #product-grid. Zonder JavaScript werkt de knop als gewone link naar pagina 2. */
(() => {
  if (window.bbLoadMoreBound) return;
  window.bbLoadMoreBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.bb-load-more__button');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') return;

    const wrapper = button.closest('.bb-load-more');
    const sectionId = wrapper && wrapper.dataset.sectionId;
    const nextUrl = button.dataset.url;
    if (!sectionId || !nextUrl) {
      window.location.href = button.href;
      return;
    }

    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    const originalLabel = button.textContent;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');
    button.textContent = button.dataset.loadingLabel || originalLabel;

    try {
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = document.getElementById('product-grid');
      const newGrid = doc.getElementById('product-grid');
      if (!grid || !newGrid) throw new Error('grid not found');

      const items = Array.from(newGrid.children);
      items.forEach((item) => grid.appendChild(item));

      const newWrapper = doc.querySelector('.bb-load-more');
      if (newWrapper) {
        wrapper.replaceWith(newWrapper);
      } else {
        wrapper.remove();
      }

      window.history.replaceState({}, '', nextUrl);

      const firstNew = items[0] && items[0].querySelector('a, button');
      if (firstNew) firstNew.focus({ preventScroll: true });
    } catch (error) {
      window.location.href = nextUrl;
    }
  });
})();
